import { CreditorDataList } from "Components/CreditorDataList"
import React from "react"
import { useVendor } from "Shared/queries/vendors/vendor.queries"
import { DeliveryNote } from "../types/deliveryNote.interfaces"

interface DeliveryNoteVendorTabContentProps {
    deliveryNote: DeliveryNote
}

export const DeliveryNoteVendorTabContent = ({ deliveryNote }: DeliveryNoteVendorTabContentProps) => {
    const { data: deliveryNoteVendor } = useVendor(deliveryNote.vendor?._id, true)

    if (!deliveryNoteVendor) {
        return <></>
    }

    return <CreditorDataList documentCreditor={deliveryNoteVendor} document={deliveryNote} isUpdating={false} canEditItems={false} />
}
